///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2023 - 2023
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React from "react";

import messages from "../../helpers/messages";

export const NoteIcon = ({
  height,
  fill = "none",
  title = messages.note.defaultMessage,
  width,
  ...props
}) => (
  <svg
    aria-labelledby="note-icon"
    height={height}
    width={width}
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title id="note-icon">{title}</title>
    <path
      fill="#0066FA"
      fillRule="evenodd"
      d="M10.163.003H2.166A.666.666 0 0 0 1.5.669v10.662c0 .368.298.667.666.667h7.997a.666.666 0 0 0 .666-.667V.67a.666.666 0 0 0-.666-.666Zm-.666 10.662H2.833v-9.33h6.664v9.33ZM8.164 2.668H4.166v1.333h3.998V2.668Zm0 5.331H4.166v1.333h3.998V8Zm0-2.665H4.166v1.333h3.998V5.334Z"
      clipRule="evenodd"
    />
  </svg>
);

export default NoteIcon;
